import classNames from 'classnames';
import React, { useState } from 'react';
import { api } from '../../services/api.js';
import { Button } from '../button/index.js';
import { ModalDialog, Dialog } from '../dialog/index.js';
import { MaterialAssignmentDialogHeader } from './components/MaterialAssignmentDialogHeader.js';
import { MaterialAssignmentRow } from './components/MaterialAssignmentRow.js';
import styles from './MaterialAssignmentModal.module.css.js';

function createInitialDoneMaterials(materials) {
    return materials.reduce((acc, material) => {
        acc[material.id] = material.isDone;
        return acc;
    }, {});
}
function MaterialAssignmentModal({ title, materials, assignmentId, moduleId, sharedBy, translations, onClose, onSubmit, onOpenMaterial, tokenAccessor, studioGroup, }) {
    const [isDoneMaterials, setIsDoneMaterials] = useState(createInitialDoneMaterials(materials));
    const isAllDone = Object.values(isDoneMaterials).every(Boolean);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const markAsDone = (id) => {
        setIsDoneMaterials({
            ...isDoneMaterials,
            [id]: !isDoneMaterials[id],
        });
    };
    const confirmDisabled = isSubmitting || materials.every(m => m.isDone) || !isAllDone;
    const handleSubmit = async () => {
        setIsSubmitting(true);
        const token = await tokenAccessor.tokenGetter();
        const headers = { Authorization: `Bearer ${token}`, studioGroup };
        let error;
        try {
            await api.post(`/api/studio/user/modules/${moduleId}/assignments/${assignmentId}/exercise-session/closed`, undefined, {
                headers,
            });
        }
        catch (e) {
            error = e;
            setIsSubmitting(false);
        }
        onSubmit(error);
    };
    return (React.createElement(ModalDialog, { id: 'material-assignment-modal', onClose: onClose, closeTitle: translations.close, closeViaEscape: true },
        React.createElement(MaterialAssignmentDialogHeader, { title: title, breadcrumbName: translations.task }),
        React.createElement(Dialog.Body, null,
            React.createElement("div", { className: styles.container, "data-testid": 'modal-body' },
                React.createElement("div", { className: styles.sidePanel },
                    React.createElement("div", { className: styles.metaContainer },
                        React.createElement("span", { className: styles.label },
                            React.createElement("i", { className: classNames('bc-icon', 'bc-icon-calendar') }),
                            React.createElement("b", null, translations.deadline)),
                        React.createElement("span", { className: styles.label },
                            React.createElement("i", { className: classNames('bc-icon', 'bc-icon-account') }),
                            React.createElement("b", null, sharedBy)))),
                React.createElement("div", { className: styles.main },
                    React.createElement("div", { className: styles.title }, translations.title),
                    React.createElement("div", { className: styles.rowsContainer }, materials.map(material => (React.createElement(MaterialAssignmentRow, { key: material.id, material: material, onOpenMaterial: onOpenMaterial, translations: translations, markAsDone: markAsDone, isDone: Boolean(isDoneMaterials[material.id]) }))))))),
        React.createElement(Dialog.Footer, { "data-testid": 'modal-footer' },
            React.createElement(Button, { variant: 'secondary', onClick: onClose }, translations.cancel),
            React.createElement(Button, { variant: 'primary', onClick: handleSubmit, disabled: confirmDisabled }, translations.confirm))));
}

export { MaterialAssignmentModal };
